import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useTheme } from '@/contexts/ThemeContext';
import { cn } from '@/lib/utils';

const ThemeToggle = ({ collapsed = false, className }) => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <Button
      variant="ghost"
      size={collapsed ? "icon" : "default"}
      onClick={toggleTheme}
      data-testid="theme-toggle-btn"
      className={cn(
        "transition-all duration-300",
        collapsed ? "w-10 h-10" : "w-full justify-start gap-2",
        "text-muted-foreground hover:text-foreground hover:bg-accent/50",
        className
      )}
      title={isDark ? "Mudar para modo claro" : "Mudar para modo escuro"}
    >
      <div className="relative w-5 h-5">
        <Sun 
          className={cn(
            "absolute inset-0 h-5 w-5 transition-all duration-300",
            isDark ? "rotate-90 scale-0 opacity-0" : "rotate-0 scale-100 opacity-100"
          )} 
        />
        <Moon 
          className={cn(
            "absolute inset-0 h-5 w-5 transition-all duration-300",
            isDark ? "rotate-0 scale-100 opacity-100" : "-rotate-90 scale-0 opacity-0"
          )} 
        />
      </div>
      {!collapsed && (
        <span className="text-sm">
          {isDark ? 'Modo Claro' : 'Modo Escuro'}
        </span>
      )}
    </Button>
  );
};

export default ThemeToggle;
